
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 mb-4">
            Assessment Platform
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            Professional assessment management system
          </p>
        </div>
        
        <div className="space-y-4">
          <Button asChild className="w-full" size="lg">
            <Link to="/admin">
              Access Admin Dashboard
            </Link>
          </Button>
          
          <p className="text-sm text-gray-500">
            Admin access required. Contact your administrator for access.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Index;
